/**
 * 拼 class 名。
 *
 * 故意不引 clsx / tailwind-merge：这个产品的组件外观是完全自定义的，
 * 一个组件的 class 从哪儿来是清楚的，没有需要「后来的覆盖先前的」那种合并场景。
 * 真遇到了再说，先不为了它引两个依赖。
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
